/**
 * Whether a key press belongs to what has the focus rather than to the video page's shortcuts: typing in a field
 * (Backspace in "Tell it what it missed" must not remove the picked object), a slider's arrows, and Enter or Space
 * on a button (Enter on Cancel in the add confirm must not add). Letters and arrows on a button stay shortcuts.
 * The seek bar (a range input) keeps only the keys that move it: after a drag it still has the focus, and Space
 * must still play or pause. Shift + arrow is the page's one-second jump, which a range would turn into a step.
 */
const TYPING = /^(INPUT|TEXTAREA|SELECT)$/;
const PRESSABLE =
	'button,a,[role="button"],[role="menuitem"],[role="option"],[role="checkbox"],[role="radio"]';
const SLIDER_KEYS = /^(Arrow(Left|Right|Up|Down)|Home|End|Page(Up|Down))$/;

/**
 * Esc while the player is full screen leaves full screen (the browser does that) and nothing else. Browsers differ
 * on whether the page sees that key press, so every Esc handler on the page ignores it either way.
 */
export const keyLeavesFullscreen = e =>
	e.key === 'Escape' && typeof document !== 'undefined' && !!document.fullscreenElement;

export const keyBelongsToFocus = (
	e,
	el = typeof document === 'undefined' ? null : document.activeElement
) => {
	if (!el || el === el.ownerDocument?.body) return false;
	if (el.tagName === 'INPUT' && el.type === 'range')
		return SLIDER_KEYS.test(e.key) && !e.shiftKey;
	if (TYPING.test(el.tagName || '') || el.isContentEditable) return true;
	if (el.closest?.('[role="slider"]')) return true;
	return (e.key === 'Enter' || e.key === ' ') && !!el.closest?.(PRESSABLE);
};
